import { Suspense, useContext, useEffect, useState } from "react";
import { Canvas, useLoader } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { DoubleSide, TextureLoader } from "three";
import img from "../../../assets/images/map.jpeg";
import { CanvasLaoder } from "../threeD/CanvasLaoder";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  Delete,
  Get,
  Patch,
  Post,
  handleError,
} from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import { Location } from "../threeD/Location";
import { toast } from "react-toastify";
import BackButton from "../../../components/modals/AddAssetModal/BackButton/BackButton";
import Select from "react-select";
import { useCommanData } from "../../../contexts/commanData.context";
import MultiLocation from "../threeD/MultiLocation";
import { IoIosAdd, IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { AiTwotoneDelete } from "react-icons/ai";

export default function AddPoint({ opacity }: any) {
  const zDimaintion = 0.001;
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { floorId } = useParams();
  const { getValidToken, getProfile, userData } = useContext(UserContext);
  const { API_LINK } = useCommanData();

  const services =
    userData[0]?.asdc_client_contract?.client_service_relationship.map(
      (service: any) => service.asdc_client_service,
    );

  const defaultDimensions = {
    x: 0,
    y: 0,
  };
  const defaultPointValues = {
    point_name: "",
    point_serial: "",
    point_title:
      services?.reduce((acc: any, service: any) => {
        acc[service.asdc_client_service_name] = "";
        return acc;
      }, {}) || {},
    bio:
      services?.reduce((acc: any, service: any) => {
        acc[service.asdc_client_service_name] = "";
        return acc;
      }, {}) || {},
    description:
      services?.reduce((acc: any, service: any) => {
        acc[service.asdc_client_service_name] = "";
        return acc;
      }, {}) || {},
    location: [],
    color: "",
    // point_type: "single_location",
  };

  const [pointValues, setPointValues] = useState<any>(defaultPointValues);
  const [floor, setFloor] = useState({} as any);
  const [activeStep, setActiveStep] = useState(0);
  const [targetPin, setTargetPin] = useState({} as any);
  const [toggleDelete, setToggleDelete] = useState(false);
  const [assignePointLocation, setAssignePointLocation] = useState(false);
  const [floorImage, setFloorImage] = useState("");
  const [selectedUnlocatedPoint, setSelectedUnlocatedPoint] = useState(
    {} as any,
  );
  const mapLoader = useLoader(
    TextureLoader,
    floorImage ? API_LINK + floorImage : img,
  );
  const [dimensions, setDimensions] = useState(defaultDimensions);
  const [multiDimensions, setMultiDimensions] = useState([
    defaultDimensions,
  ] as any);
  const [selectedMultiPoint, setSelectedMultiPoint] = useState<number>(0);
  // const blackLocation = `<svg id="e7VFMeugItN1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><ellipse rx="50.269974" ry="50.269974" transform="matrix(2.429831 0 0 2.429833 150 150)" fill="none" stroke="hsl(0,0%,0%)" stroke-width="10"/><ellipse rx="104.949594" ry="104.949594" transform="matrix(.885693 0 0 0.885689 150 150)" stroke-width="0"/></svg>`;
  const navigate = useNavigate();

  // console.log(pointValues);
  // console.log(userData);

  const meshDimensions = { width: 3, height: 3 };

  const unLocatioedPointsOptions =
    floor?.points
      ?.filter((point: any) => point.point_position_layout.length === 0)
      .map((point: any) => ({
        value: point.point_id,
        label: point.point_name + " - " + "No:" + point?.serial,
      })) || [];

  const pointTypeOptions = [
    { value: "single_location", label: t("single_location") },
    { value: "multiple_location", label: t("multiple_location") },
  ];

  const getFloor = async () => {
    const res = await Get(
      `floors/get-floor?floor_id=${floorId}`,
      getValidToken(),
    );
    if (res.error || !res.data) {
      return;
    } else {
      setFloor(res.data);
      if (
        res.data?.points?.filter(
          (point: any) =>
            point.point_id.toString() === searchParams.get("pointId") &&
            point.point_position_layout.length !== 0,
        ).length === 1
      ) {
        if (searchParams.get("pointId")) {
          const point = res.data?.points?.filter(
            (point: any) =>
              point.point_id.toString() === searchParams.get("pointId"),
          )[0] as any;
          setTargetPin(point);
          // if (point.point_type === "single_location") {
          //   setDimensions({
          //     x: JSON.parse(point.point_position_layout)[0],
          //     y: JSON.parse(point.point_position_layout)[1],
          //   });
          // }
          // if (point.point_type === "multiple_location") {
          //   setMultiDimensions(
          //     JSON.parse(point.point_position_layout).map((loc: any) => ({
          //       x: loc[0],
          //       y: loc[1],
          //     }))
          //   );
          // }
        } else {
          setTargetPin({} as any);
        }
      } else {
        setTargetPin({} as any);
      }
      setFloorImage(res.data.logo_url);
    }
  };
  // console.log(selectedUnlocatedPoint);

  useEffect(() => {
    searchParams.get("pointId") === null && setActiveStep(1);
    floorId && getFloor();
  }, []);
  useEffect(() => {
    floor?.points?.length > 0 &&
      searchParams.get("pointId") !== null &&
      targetPin.point_id === undefined &&
      setSelectedUnlocatedPoint(
        floor?.points?.find(
          (point: any) =>
            point.point_id.toString() === searchParams.get("pointId"),
        ) as any,
      );
  }, [floor]);

  const handleSave = async () => {
    const res = await Post(
      `points/add-point`,
      {
        site_id: floor.site_id,
        floor_id: floorId,
        asdc_client_contract_id: userData[0].asdc_client_contract_id,
        point_name: pointValues.point_name,
        point_serial: pointValues.point_serial,
        point_title: pointValues.point_title,
        color: "color4",
        bio: pointValues.bio,
        decription: pointValues.description,
        // point_type: pointValues.point_type,
        // point_position_layout:
        //   pointValues.point_type === "single_location"
        //     ? [[dimensions.x, dimensions.y]]
        //     : multiDimensions.map((loc: any) => [loc.x, loc.y]),
      },
      getValidToken(),
    );
    if (res.error || !res.data) {
      handleError(res);
    } else {
      toast.success("Point added successfully");
      floorId && getFloor();
      setActiveStep(0);
      setPointValues(defaultPointValues);
      setDimensions({ x: 0, y: 0 });
      setMultiDimensions([defaultDimensions]);
      setTargetPin({});
      getProfile();
    }
  };
  const handleEdit = async () => {
    const res = await Patch(
      `points/update-point?point_id=${
        !assignePointLocation
          ? targetPin.point_id
          : floor?.points?.find(
              (point: any) => point.point_name === pointValues.point_name,
            )?.point_id
      }`,
      {
        site_id: floor.site_id,
        floor_id: floorId,
        asdc_client_contract_id: userData[0].asdc_client_contract_id,
        point_name: pointValues.point_name,
        point_serial: pointValues.point_serial,
        point_title: pointValues.point_title,
        color: !assignePointLocation
          ? targetPin.color
          : floor?.points?.find(
              (point: any) => point.point_name === pointValues.point_name,
            )?.color,
        bio: pointValues.bio,
        decription: pointValues.description,
        // point_type: pointValues.point_type,
        // point_position_layout:
        //   pointValues.point_type === "single_location"
        //     ? [[dimensions.x, dimensions.y]]
        //     : multiDimensions.map((loc: any) => [loc.x, loc.y]),
      },
      getValidToken(),
    );
    if (res.error) {
      handleError(res);
    } else {
      toast.success("Point Updated successfully");
      floorId && getFloor();
      setActiveStep(0);
      setPointValues(defaultPointValues);
      setDimensions({ x: 0, y: 0 });
      setMultiDimensions([defaultDimensions]);
      setTargetPin({});
      setAssignePointLocation(false);
    }
  };
  const deletePoint = async () => {
    const res = await Delete(
      `points/delete-point?point_id=${targetPin.point_id}`,
      getValidToken(),
    );
    if (res.error) {
      handleError(res);
    } else {
      toast.success("Point Deleted successfully");
      floorId && getFloor();
      setActiveStep(0);
      setPointValues(defaultPointValues);
      setDimensions({ x: 0, y: 0 });
      setMultiDimensions([defaultDimensions]);
      setTargetPin({});
      setToggleDelete(false);
      getProfile();
    }
  };

  return (
    <>
      <div className={`w-full relative h-[83vh] ${opacity ? "" : "hidden"}`}>
        <BackButton
          cb={() => {
            activeStep > 0 ? setActiveStep(activeStep - 1) : navigate(-1);
          }}
          position={`absolute top-[1.4rem] z-10 w-fit ${
            i18next.language === "en" ? "left-0" : "right-0"
          }`}
        />
        <div
          className={`h-full w-[180vw] flex justify-between duration-300 ${
            activeStep === 2 && i18next.language === "en"
              ? "-translate-x-[90vw]"
              : ""
          } ${
            activeStep === 2 && i18next.language === "ar"
              ? "translate-x-[90vw]"
              : ""
          }`}
        >
          <div className="relative w-1/2">
            <Canvas className={`bg-background duration-300`}>
              <PerspectiveCamera
                makeDefault
                position={[1, 6, 8]}
                fov={34}
                near={0.1}
                key={activeStep + " camera " + floor.name}
              />
              <Suspense fallback={<CanvasLaoder />}>
                <OrbitControls
                  enableRotate={false}
                  enabled={true}
                  // enableZoom={false}
                  // enablePan={false}
                  // minPolarAngle={Math.PI / 6}
                  // maxPolarAngle={(3 * Math.PI) / 6}
                  // minAzimuthAngle={-Math.PI / 8}
                  // maxAzimuthAngle={Math.PI / 5}
                />
                <ambientLight intensity={0.8} />
                <directionalLight
                  position={[0, 10, 0]}
                  intensity={2}
                  castShadow
                />
                <group position={[-0.5, 2.7, 0.5]}>
                  <mesh
                    onClick={() => {
                      // if (pointValues.point_type === "multiple_location") {
                      //   const newArray = [...multiDimensions];
                      //   newArray[selectedMultiPoint] = {
                      //     x: e.point.x * (102 / 100) + 0.5,
                      //     y: e.point.y * (115 / 100) - 0.75,
                      //   };
                      //   setMultiDimensions(newArray);
                      // }
                      // if (pointValues.point_type === "single_location") {
                      //   setDimensions({
                      //     x: e.point.x * (102 / 100) + 0.5,
                      //     y: e.point.y * (115 / 100) - 0.75,
                      //   });
                      // }
                      // console.log(e);
                    }}
                    rotation={[-0.6, 0.05, 0.07]}
                    position={[0, -2, 0]}
                    // onClick={(e) => console.log(e)}
                  >
                    <planeGeometry
                      args={[meshDimensions.width, meshDimensions.height, 1]}
                      attach="geometry"
                    />
                    <meshStandardMaterial
                      map={mapLoader}
                      attach="material"
                      side={DoubleSide}
                    />
                    <group>
                      {floor?.points?.map((point: any, i: number) => {
                        if (point.point_position_layout.length === 0) {
                          return;
                        }
                        // console.log(point);
                        return (
                          <group
                            onClick={(e) => {
                              e.stopPropagation();
                              if (activeStep === 0) {
                                setTargetPin(point);
                                if (point) {
                                  setDimensions({
                                    x: JSON.parse(
                                      point.point_position_layout,
                                    )[0],
                                    y: JSON.parse(
                                      point.point_position_layout,
                                    )[1],
                                  });
                                } else {
                                  setMultiDimensions(
                                    JSON.parse(point.point_position_layout).map(
                                      (loc: any) => ({ x: loc[0], y: loc[1] }),
                                    ),
                                  );
                                }
                              }
                            }}
                            key={i}
                          >
                            {point?.point_type === "single_location" && (
                              <Location
                                active={
                                  targetPin?.point_id === point.point_id &&
                                  activeStep === 1
                                    ? false
                                    : true
                                }
                                position={
                                  point.point_position_layout.length > 0
                                    ? ([
                                        ...JSON.parse(
                                          point.point_position_layout,
                                        )[0],
                                        zDimaintion,
                                      ] as any)
                                    : [0, 0, 0]
                                }
                                color={
                                  activeStep > 0 ||
                                  (targetPin.point_id !== undefined &&
                                    targetPin.point_id !== point.point_id)
                                    ? point.color + "Opacity"
                                    : point.color
                                }
                              />
                            )}
                            {point?.point_type === "multiple_location" &&
                              (targetPin?.point_id !== point.point_id ||
                                activeStep !== 1) && (
                                <MultiLocation
                                  point={point}
                                  position={
                                    point.point_position_layout.length > 0 &&
                                    JSON.parse(point.point_position_layout)
                                  }
                                  zDimaintion={zDimaintion}
                                  color={
                                    activeStep > 0 ||
                                    (targetPin.point_id !== undefined &&
                                      targetPin.point_id !== point.point_id)
                                      ? point.color + "Opacity"
                                      : point.color
                                  }
                                />
                              )}
                          </group>
                        );
                      })}
                      {/* {activeStep > 0 &&
                        pointValues?.point_type === "single_location" && (
                          <Svg
                            // onPointerDown={(e) => console.log(e)}
                            // onPointerMissed={(e) => {
                            //   console.log(e);
                            //   // setDimensions({ x: e.clientX / 500, y: e.clientY / 500 }
                            // }}
                            position={[dimensions.x, dimensions.y, zDimaintion]}
                            src={blackLocation}
                            rotation={[0, 0, -0.15]}
                            scale={[0.00007, 0.00007, 0.00007]}
                          />
                        )}
                      {activeStep > 0 &&
                        pointValues.point_type === "multiple_location" &&
                        multiDimensions.length > 2 && (
                          <MultiLocation
                            position={[
                              ...multiDimensions,
                              //  multiDimensions[0]
                            ].map((loc) => [loc.x, loc.y])}
                            zDimaintion={zDimaintion}
                            color="color4"
                          />
                        )}
                      {activeStep > 0 &&
                        pointValues.point_type === "multiple_location" &&
                        ((selectedMultiPoint === 0 &&
                          multiDimensions.length === 1) ||
                          (selectedMultiPoint === 1 &&
                            multiDimensions.length === 2)) && (
                          <Svg
                            position={[
                              multiDimensions[0].x,
                              multiDimensions[0].y,
                              zDimaintion,
                            ]}
                            src={blackLocation}
                            rotation={[0, 0, -0.15]}
                            scale={[0.00007, 0.00007, 0.00007]}
                          />
                        )}
                      {activeStep > 0 &&
                        pointValues.point_type === "multiple_location" &&
                        selectedMultiPoint === 1 &&
                        multiDimensions.length === 2 && (
                          <Svg
                            position={[
                              multiDimensions[1].x,
                              multiDimensions[1].y,
                              zDimaintion,
                            ]}
                            src={blackLocation}
                            rotation={[0, 0, -0.15]}
                            scale={[0.00007, 0.00007, 0.00007]}
                          />
                        )} */}
                    </group>
                  </mesh>
                </group>
              </Suspense>
            </Canvas>
          </div>
          <div
            className={`w-1/2 pt-28 flex justify-center ${
              activeStep !== 2 && "opacity-0"
            }`}
          >
            <div className="w-[65rem] flex flex-col gap-6 overflow-x-auto">
              <div className="flex items-center gap-3 ms-1 pb-4 border-b">
                <div className="w-3/12 flex flex-col items-start justify-center gap-1">
                  <label htmlFor="pointTitle" className="block text-3xl mb-2">
                    {t("point_name")}
                  </label>
                  <input
                    className="w-11/12 border"
                    type="text"
                    id="pointName"
                    value={pointValues.point_name}
                    onChange={(e) =>
                      setPointValues({
                        ...pointValues,
                        point_name: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="w-3/12 flex flex-col items-start justify-center gap-1">
                  <label htmlFor="pointTitle" className="block text-3xl mb-2">
                    {t("point_serial")}
                  </label>
                  <input
                    className="w-11/12 border"
                    type="text"
                    id="pointName"
                    value={pointValues.point_serial}
                    onChange={(e) =>
                      setPointValues({
                        ...pointValues,
                        point_serial: e.target.value,
                      })
                    }
                  />
                </div>
                <div
                  className={`w-5/12 ${activeStep !== 2 && ""}
              ${i18next.language === "ar" ? "" : ""}`}
                >
                  {floor?.points?.filter(
                    (point: any) => point.point_position_layout.length === 0,
                  ).length > 0 &&
                    targetPin.point_id === undefined &&
                    activeStep === 2 && (
                      <>
                        <label className="block text-2xl mb-2">
                          {t("select_point_from_uploaded_excel_sheet")}
                        </label>
                        <Select
                          className="outline-none w-2/3"
                          onChange={(selectedOption: any) => {
                            const point = floor?.points?.find(
                              (point: any) =>
                                point.point_id === selectedOption.value,
                            );
                            setPointValues({
                              ...pointValues,
                              point_name: point.point_name,
                              point_title: point.point_title,
                              bio: point.bio,
                              description: point.description,
                              point_serial: point.serial,
                            });
                            setAssignePointLocation(true);
                          }}
                          value={unLocatioedPointsOptions.find(
                            (option: any) =>
                              option.label === pointValues.point_title,
                          )}
                          options={unLocatioedPointsOptions}
                          placeholder={t("select_point")}
                        />
                      </>
                    )}
                </div>
              </div>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-collapse border-2">
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("service")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("point_title")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("point_bio")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("point_description")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="h-6">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  {services?.map((service: any, i: number) => {
                    const serviceName = service.asdc_client_service_name;
                    return (
                      <tr key={i} className="border-collapse border-2">
                        <td className="border-collapse border-2 p-3 capitalize min-w-[200px]">
                          {service.asdc_client_service_name}
                        </td>
                        <td className="border-collapse border-2 p-3 capitalize min-w-[200px]">
                          <input
                            className="w-11/12 border"
                            type="text"
                            id={serviceName + "pointTitle"}
                            value={pointValues.point_title[serviceName]}
                            onChange={(e) =>
                              setPointValues({
                                ...pointValues,
                                point_title: {
                                  ...pointValues.point_title,
                                  [serviceName]: e.target.value,
                                },
                              })
                            }
                          />
                        </td>
                        <td className="border-collapse border-2 p-3 capitalize min-w-[200px]">
                          <input
                            className="w-11/12 border"
                            type="text"
                            id={serviceName + "pointBio"}
                            value={pointValues.bio[serviceName]}
                            onChange={(e) =>
                              setPointValues({
                                ...pointValues,
                                bio: {
                                  ...pointValues.bio,
                                  [serviceName]: e.target.value,
                                },
                              })
                            }
                          />
                        </td>
                        <td className="border-collapse border-2 p-3 capitalize min-w-[200px]">
                          <textarea
                            className="w-11/12 border h-8 p-1 text-xs"
                            id={serviceName + "pointDesc"}
                            value={pointValues.description[serviceName]}
                            onChange={(e) =>
                              setPointValues({
                                ...pointValues,
                                description: {
                                  ...pointValues.description,
                                  [serviceName]: e.target.value,
                                },
                              })
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          className={`absolute top-5 flex flex-col gap-5 w-fit text-5xl ${
            i18next.language === "ar" ? "right-24" : "left-24"
          }`}
        >
          {floor.name}
        </div>
        {activeStep === 0 && targetPin.point_id === undefined && (
          <div
            className={`absolute top-16 grid place-content-center cursor-pointer text-xl bg-primary hover:bg-secondary text-text font-bold py-2 w-28 rounded duration-200 ${
              i18next.language === "en" ? "right-5" : "left-5"
            }`}
            onClick={() => setActiveStep(1)}
          >
            {t("add_point")}
          </div>
        )}
        {activeStep === 0 && targetPin.point_id !== undefined && (
          <div
            className={`absolute bottom-14 left-1/2 -translate-x-1/2 flex flex-col gap-7`}
          >
            <div className="flex items-center justify-center gap-2">
              <h2 className="text-2xl">{t("point_title")} :</h2>
              <p className="text-3xl">{targetPin.point_name}</p>
            </div>
            <div className={`flex gap-5`}>
              <button
                onClick={() => {
                  setTargetPin({});
                  setDimensions({ x: 0, y: 0 });
                }}
                className="border-text border-solid border-[1px] hover:bg-text hover:text-white font-bold py-2 w-20 rounded duration-200"
              >
                {t("cancel")}
              </button>
              <button
                onClick={() => {
                  setActiveStep(1);
                  setPointValues({
                    point_name: targetPin.point_name,
                    point_title: targetPin.point_title,
                    bio: targetPin.bio,
                    description: targetPin.description,
                    // point_type: targetPin.point_type,
                  } as any);
                }}
                className="bg-primary hover:bg-secondary text-text font-bold py-2 w-20 rounded duration-200"
              >
                {t("edit")}
              </button>
              <button
                onClick={() => setToggleDelete(true)}
                className="bg-red-500 hover:bg-red-600 text-text font-bold py-2 w-20 rounded duration-200"
              >
                {t("delete")}
              </button>
            </div>
          </div>
        )}
        {activeStep === 0 &&
          selectedUnlocatedPoint.point_id !== undefined &&
          targetPin.point_id === undefined && (
            <div
              className={`absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col gap-7`}
            >
              <h2 className="text-2xl text-red-500 flex gap-2">
                <span className="font-bold">
                  {selectedUnlocatedPoint.point_name}
                </span>
                {t("has_no_location")}
              </h2>
            </div>
          )}
        {activeStep === 1 && (
          <div
            className={`absolute top-10 flex flex-col gap-5 w-1/4 ${
              i18next.language === "en" ? "right-0" : "left-0"
            }`}
          >
            <h2 className="text-2xl font-bold">{t("choose_point_type")} :</h2>
            <Select
              className="w-8/12"
              options={pointTypeOptions}
              onChange={(selectedOption: any) =>
                setPointValues({
                  ...pointValues,
                  point_type: selectedOption.value,
                })
              }
              value={pointTypeOptions.find(
                (option: any) => option.value === pointValues.point_type,
              )}
              placeholder={t("select_point_type")}
            />
            <h2 className="text-2xl font-bold">
              {t("choose_point_location")} :
            </h2>
            <div className="flex items-center gap-4">
              <label htmlFor="x" className="text-3xl">
                X:
              </label>
              <input
                className="w-full accent-primary !border-0 !outline-0"
                type="range"
                name="x"
                id="x"
                value={
                  pointValues.point_type === "single_location"
                    ? dimensions.x
                    : multiDimensions[selectedMultiPoint].x
                }
                onChange={(e) => {
                  if (pointValues.point_type === "single_location") {
                    setDimensions({ ...dimensions, x: +e.target.value });
                  }
                  if (pointValues.point_type === "multiple_location") {
                    const newArray = [...multiDimensions];
                    newArray[selectedMultiPoint] = {
                      x: +e.target.value,
                      y: multiDimensions[selectedMultiPoint].y,
                    };
                    setMultiDimensions(newArray);
                  }
                }}
                min={-meshDimensions.width / 2 - 0.1}
                max={meshDimensions.width / 2 - 0.2}
                step={0.0001}
              />
            </div>
            <div className="flex items-center gap-4">
              <label htmlFor="y" className="text-3xl">
                Y:
              </label>
              <input
                className="w-full accent-primary !border-0 !outline-0"
                type="range"
                name="y"
                id="y"
                value={
                  pointValues.point_type === "single_location"
                    ? dimensions.y
                    : multiDimensions[selectedMultiPoint].y
                }
                onChange={(e) => {
                  if (pointValues.point_type === "single_location") {
                    setDimensions({ ...dimensions, y: +e.target.value });
                  }
                  if (pointValues.point_type === "multiple_location") {
                    const newArray = [...multiDimensions];
                    newArray[selectedMultiPoint] = {
                      x: multiDimensions[selectedMultiPoint].x,
                      y: +e.target.value,
                    };
                    setMultiDimensions(newArray);
                  }
                }}
                min={-meshDimensions.height / 2 + 0.2}
                max={meshDimensions.height / 2}
                step={0.0001}
              />
            </div>
            {pointValues.point_type === "multiple_location" && (
              <div className="">
                <div className="flex items-center gap-2">
                  <span className="">{t("point_number")} :</span>
                  <IoIosArrowBack
                    className={`text-primary text-5xl cursor-pointer`}
                    onClick={() =>
                      setSelectedMultiPoint(
                        selectedMultiPoint === 0
                          ? multiDimensions.length - 1
                          : selectedMultiPoint - 1,
                      )
                    }
                  />
                  <span className="text-4xl mx-3">
                    {selectedMultiPoint + 1}
                  </span>
                  <IoIosArrowForward
                    className={`text-primary text-5xl cursor-pointer`}
                    onClick={() =>
                      setSelectedMultiPoint(
                        selectedMultiPoint === multiDimensions.length - 1
                          ? 0
                          : selectedMultiPoint + 1,
                      )
                    }
                  />
                </div>
                <div className="flex items-center">
                  <IoIosAdd
                    className={`text-primary text-5xl cursor-pointer`}
                    onClick={() => {
                      setMultiDimensions([
                        ...multiDimensions,
                        defaultDimensions,
                      ]);
                      setSelectedMultiPoint(selectedMultiPoint + 1);
                    }}
                  />
                  {multiDimensions.length > 1 && (
                    <AiTwotoneDelete
                      className={`text-red-500 text-4xl cursor-pointer`}
                      onClick={() => {
                        setMultiDimensions(
                          multiDimensions.filter(
                            (loc: any, i: number) => i !== selectedMultiPoint,
                          ),
                        );
                        setSelectedMultiPoint(
                          selectedMultiPoint === 0 ? 0 : selectedMultiPoint - 1,
                        );
                      }}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {activeStep > 0 && (
        <div
          className={`absolute bottom-20 flex gap-5 ${
            i18next.language === "en" ? "right-10" : "left-10"
          } ${opacity ? "" : "hidden"}`}
        >
          {activeStep === 1 ? (
            <button
              onClick={() => {
                setActiveStep(0);
                setPointValues(defaultPointValues);
                setDimensions({ x: 0, y: 0 });
                setMultiDimensions([defaultDimensions]);
                setTargetPin({});
                setAssignePointLocation(false);
              }}
              className="border-text border-solid border-[1px] hover:bg-text hover:text-background font-bold py-2 w-20 rounded duration-200"
            >
              {t("cancel")}
            </button>
          ) : (
            <button
              onClick={() => setActiveStep(1)}
              className="border-text border-solid border-[1px] hover:bg-text hover:text-background font-bold py-2 w-20 rounded duration-200"
            >
              {t("back")}
            </button>
          )}
          {activeStep === 1 ? (
            <button
              onClick={() => setActiveStep(2)}
              className="bg-primary hover:bg-secondary text-text font-bold py-2 w-20 rounded duration-200"
            >
              {t("next")}
            </button>
          ) : (
            <button
              onClick={() => {
                targetPin.point_id !== undefined || assignePointLocation
                  ? handleEdit()
                  : handleSave();
              }}
              className="bg-primary hover:bg-secondary text-text font-bold py-2 w-20 rounded duration-200"
            >
              {t("save")}
            </button>
          )}
        </div>
      )}
      {toggleDelete && (
        <div
          className={`pointer-events-auto w-full min-h-screen z-[100] flex justify-center items-center fixed top-0 left-0 bg-[#3b3b3be3] ${
            opacity ? "" : "hidden"
          }`}
        >
          <div className="bg-white p-16 flex flex-col gap-6 rounded-lg">
            <div className="flex gap-1 justify-center items-center">
              <h2 className="text-xl">{t("are_you_sure_want_to_delete")}:</h2>
              <h2 className="text-2xl">{targetPin.point_name}</h2>
            </div>
            <div className="flex items-center gap-3">
              <button
                className={`py-2 px-12 text-white bg-red-500`}
                onClick={() => deletePoint()}
              >
                {t("delete")}
              </button>
              <button
                onClick={() => {
                  setToggleDelete(false);
                }}
                className="py-2 px-12 border-[1px] border-solid border-black"
              >
                {t("cancelBtn")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
